import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

export class AmbassadorManagementAPI implements IAPI {
  prefix = '/AmbassadorManagement'

  fetchList (params: TAmbassadorManagementAPI.Params.FetchList) {
    const url = appendParams(`${this.prefix}/VoteList`, { ...params })
    return API.get<TAmbassadorManagement.TState['ambassadorList']>(url)
  }

  async downloadExcelFile (data: any) {
    const url = appendParams(`${API.defaults.baseURL}${this.prefix}/VoteFile`, data)
    const response = await API.get(url, { responseType: 'blob' })
    return response.data
  }
}

export const ambassadorManagementApi = new AmbassadorManagementAPI()
